import React from "react";
import "./product-slider.styles.css";

const ProductSlider = ({ images, currentIndex, setCurrentIndex }) => {
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="image-slider">
      <div className="slider-wrapper">
        {images.length > 0 ? (
          <>
            <img
              src={images[currentIndex]}
              alt={`Slide ${currentIndex}`}
              className="slider-image"
            />
            <button className="slider-button prev-button" onClick={handlePrev}>
              &#10094;
            </button>
            <button className="slider-button next-button" onClick={handleNext}>
              &#10095;
            </button>
          </>
        ) : (
          <p>No images available</p>
        )}
      </div>
    </div>
  );
};

export default ProductSlider;
